module.exports = __webpack_public_path__ + "55f45499576f343a79f82a977a91c005.svg";